import React from 'react';
import { GrFormPrevious, GrFormNext } from 'react-icons/gr';
import './Pagination.css';

const Pagination = ({ currentPage, totalPages, onPrev, onNext }) => {
    return (
        <div className='pagination-wrapper'>
            <div className="custom-pagination">
                <button
                    className="custom-pagination-btn"
                    onClick={onPrev}
                    disabled={currentPage === 1}
                >
                    <GrFormPrevious className="custom-pagination-icon" />
                </button>

                <span className="custom-pagination-info">{currentPage}/{totalPages }</span>

                <button
                    className="custom-pagination-btn"
                    onClick={onNext}
                    disabled={currentPage === totalPages}
                >
                    <GrFormNext className="custom-pagination-icon" />
                </button>
            </div>
        </div>
    );
};

export default Pagination;
